<template>
    <div class="lot__content">
        <div class="lot__info-item">
            <span class="lot__info-name">Всего ставок</span>
            <span class="lot__bets">{{ lot.bids.length }}</span>
        </div>
        <div class="lot__bet" v-if="lot.bids.length && lot.bids[0].city">
            Текущая ставка из
            <span class="lot__bet-city">{{ lot.bids[0].city.title }}</span>
        </div>
        <div class="lot__app">
            <svg class="lot__app-icon">
                <use xlink:href="/assets/front/img/sprite.svg#icon-phone"></use>
            </svg>
            <div>
                <div class="lot__app-description">
                    Чтобы принять участие в аукционе скачате приложение на Ваше мобильное устройство
                </div>
                <button class="btn btn--main btn--middle">Скачать</button>
            </div>
        </div>
        <div class="lot__links">
            <a  href="https://antiqbay.com/storage/bidding-rules/rules.pdf" target="_blank" class="lot__link">
                <svg class="lot__link-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-info"></use>
                </svg>
                Правила торгов
            </a>
            <a href="#" v-on:click.stop="visible = true" class="lot__link">
                <svg class="lot__link-icon">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-share"></use>
                </svg>
                Поделиться лотом
            </a>
        </div>
        <el-dialog
                class="popup"
                :width="windowWidth > 1200 ? '600px' : '90%'"
                :append-to-body="true"
                :show-close="false"
                :visible.sync="visible">
            <button class="btn popup__close" @click.prevent="visible = false">
                <i class="el-icon-close"></i>
            </button>
            <social-popup></social-popup>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {store} from "../../../store/lot";
    import SocialPopup from "./socialPopup";

    export default {
        name: "MobileLot",
        components: {SocialPopup},
        data: () => ({
            visible: false
        }),
        store,
        computed: {
            ...mapState([
                'lot',
            ]),
        },
    }
</script>